import getConfig from '@config/baseConfig';

const phaserConfig = getConfig();

const audio = {
  bgAudio: null,
  ripcAudio: null,
};

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio,
};

export const gameState = {
  score: 0,
  attempted: 0,
  questionNumber: 0,
  hints: 0,
  gameWin: true,
  firstMistake: false,
  cam: null,
  qnum: 0,
  correct: 0,
  attempts: 0,
  hneed: false,
  clicked: false,
  retry: false,
  hintClose: false,
  endSceneActive: false,
};
